// 영업사원 임퍼소네이션 세션 관리
// - 시작 시 rep 의 token/userInfo 를 백업하고 고객 세션으로 전환
// - 종료(finish impersonated session) 시 백업으로 복원

const BACKUP_KEY = 'repImpersonationBackup';

export const isImpersonating = () => !!localStorage.getItem(BACKUP_KEY);

export const getImpersonationBackup = () => {
  try {
    return JSON.parse(localStorage.getItem(BACKUP_KEY));
  } catch (e) {
    return null;
  }
};

// rep 세션 백업 + 고객 토큰 적용 (userInfo 전환은 호출부에서 dispatch)
export const startImpersonation = (repUserInfo, customerToken) => {
  if (isImpersonating()) return false; // 중첩 임퍼소네이션 방지
  localStorage.setItem(
    BACKUP_KEY,
    JSON.stringify({
      token: localStorage.getItem('token'),
      userInfo: repUserInfo,
    }),
  );
  localStorage.setItem('token', customerToken);
  return true;
};

// rep 세션 복원. 복원된 userInfo 반환 (dispatch 는 호출부에서)
export const finishImpersonation = () => {
  const backup = getImpersonationBackup();
  if (!backup) return null;
  localStorage.setItem('token', backup.token);
  localStorage.removeItem(BACKUP_KEY);
  return backup.userInfo;
};
